import React, { useState } from "react";
import { Column, TotalItem, Summary, Grouping } from "devextreme-react/data-grid";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import { LVGridCabeceraReporte } from "../../Componentes/Basicos/LVGridCabeceraReporte";

export const MKT_MonitorDeEMails = () => {
  const [data, setData] = useState([])
  const { MKT_Correos_AEnviar: { function_MKT_Correos_AEnviar_Listar } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  return (
    <PaginaListado
      Titulo="MONITOR DE E-MAILS"
      funcion={function_MKT_Correos_AEnviar_Listar}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive">
        {data.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={data}
            id="gridContainer"
            keyExpr="IdEnvio"
          >
            <Grouping autoExpandAll={true} />
            <Summary>
              <TotalItem
                column="IdEnvio"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
            </Summary>

            <Column caption="Código" dataField="IdEnvio" width="150" alignment="Right" dataType="number" />
            <Column caption="Acción" dataField="Accion" width="300" alignment="Left" dataType="string" />
            <Column caption="Título" dataField="Titulo" width="300" alignment="Left" dataType="string" />
            <Column caption="E-Mail" dataField="EMail" width="300" alignment="Left" dataType="string" />
            <Column caption="Fecha Programada" dataField="FechaProgramada" width="200" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha Envío" dataField="FechaEnvio" width="200" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />

          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
